<template>
  <div>
    <div class="Nav">
      <span>
        <span>订单详情</span>
        <span class="trou" v-show="this.orderData.trouble!='正常'">{{ this.orderData.trouble }}</span>
      </span>
      <span>
        <span>
          <el-button size="mini" @click="goForward">
            <i class="el-icon-back"></i>
          </el-button>
          <el-button size="mini" @click="retreat">
            <i class="el-icon-right"></i>
          </el-button>
        </span>
        <el-button
          type="primary"
          size="mini"
          v-if="orderDetailData.manualship ===1"
          @click="dialogFormVisible = true"
        >发货</el-button>
        <el-button
          type="primary"
          size="mini"
          v-if="orderDetailData.manualship ===2"
          @click="dialogFormVisible2 = true"
        >重发</el-button>
        <el-button type="primary" size="mini" @click="enterShopifyOrder">返回</el-button>
      </span>
    </div>
    <div class="container">
      <!-- 左侧 -->
      <div class="left">
        <!-- 订单总览 -->
        <div class="main">
          <div class="nav">
            <span>订单总览</span>
          </div>
          <div class="content">
            <div class="nav">
              <span>商品</span>
              <span>sku</span>
              <span>数量</span>
              <span>价格</span>
              <span>全部折扣</span>
            </div>
            <div class="item" v-for="(item,index) in orderDetailData.goodslist" :key="index">
              <span class="orderProduct">
                <div>
                  <div class="left"></div>
                  <div class="right">
                    <a href>{{ item.name }}</a>
                  </div>
                </div>
              </span>
              <span>{{ item.sku }}</span>
              <span>{{ item.quantity }}</span>
              <span>{{ item.price*item.quantity }}</span>
              <span>{{ item.discount }}</span>
            </div>
          </div>
        </div>
        <!-- 付款信息 -->
        <div class="main">
          <div class="nav">
            <span>付款信息</span>
          </div>
          <div class="content payContent">
            <div class="payItem">
              <span class="left">
                <span>小计</span>
                <span>{{ orderDetailData.shipping_address.goodsnum }}/件</span>
              </span>
              <span class="right">${{ totalPrice }}</span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>运费</span>
                <span>Express Shipping</span>
              </span>
              <span class="right">+${{ totalShippingPrice }}</span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>总计</span>
              </span>
              <span class="right">${{ Total }}</span>
            </div>
          </div>
        </div>
        <!-- 收货地址 -->
        <div class="main">
          <div class="nav" style="padding-right:8px;padding-top:8px">
            <span>收货地址</span>
            <el-button type="primary" size="mini" @click="dialogFormVisible3 = true">修改</el-button>
          </div>
          <div class="content payContent">
            <div class="payItem">
              <span class="left">
                <span>收货姓名</span>
                <span>{{ orderDetailData.shipping_address.name }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>联系电话</span>
                <span>{{ orderDetailData.shipping_address.phone }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>邮箱</span>
                <span>{{ orderDetailData.shipping_address.email }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>国家</span>
                <span>{{ orderDetailData.shipping_address.country }}</span>
              </span>
            </div>

            <div class="payItem">
              <span class="left">
                <span>邮编</span>
                <span>{{ orderDetailData.shipping_address.zip }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>省份/州</span>
                <span>{{ orderDetailData.shipping_address.province }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>城市</span>
                <span>{{ orderDetailData.shipping_address.city }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>地址1</span>
                <span>{{ orderDetailData.shipping_address.address1 }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>地址2</span>
                <span>{{ orderDetailData.shipping_address.address2 }}</span>
              </span>
            </div>
            <div class="payItem">
              <span class="left">
                <span>支付订单</span>
                <span>
                  <a
                    :href="orderDetailData.shipping_address.paysnapurl"
                    target="_blank"
                    style="color:#1890ff;"
                  >支付结果链接</a>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- 物流列表 -->
        <div class="main logisticsMain">
          <div class="nav">
            <span>物流列表</span>
          </div>
          <div class="content">
            <div class="nav">
              <span>内单号</span>
              <span>运单号</span>
              <span>描述</span>
              <span>创建时间</span>
            </div>
            <div class="item" v-for="(item,index) in k5Data" :key="index">
              <span class="orderProduct">
                <div>{{ item.customerno }}</div>
              </span>
              <span>{{ item.trackingno }}</span>
              <span>{{ item.message }}</span>
              <span>{{ item.time }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <!-- 订单信息 -->
        <div class="orderInformation">
          <div class="main">
            <div class="nav">
              <span>订单信息</span>
              <el-button type="primary" size="mini" @click="dialogFormVisible4 = true">修改</el-button>
            </div>
            <div class="wrap">
              <div class="top">
                <div>
                  <p>物流状态:</p>
                  <p>{{ orderDetailData.basic.expressstate }}</p>
                </div>
                <div>
                  <p>订单总额:</p>
                  <h2 style="font-weight:600;font-size:18px;">${{ Total }}</h2>
                </div>
              </div>
              <div class="middle">
                <div>
                  <p>订单号:</p>
                  <p>{{ orderDetailData.basic.orderno }}</p>
                </div>
                <div>
                  <p>出单店铺:</p>
                  <p>{{ orderDetailData.basic.shopname }}</p>
                </div>
                <div>
                  <p>自定义单号:</p>
                  <p>{{ orderDetailData.basic.diyorderno }}</p>
                </div>
                <div>
                  <p>下单日期:</p>
                  <p>{{ orderDetailData.basic.createdat }}</p>
                </div>
                <div>
                  <p>运单号:</p>
                  <p>{{ orderDetailData.basic.trackingno?orderDetailData.basic.trackingno:'暂无' }}</p>
                </div>
                <div>
                  <p>购物方式:</p>
                  <p>{{ orderDetailData.basic.buyway }}</p>
                </div>
                <div>
                  <p>支付渠道:</p>
                  <p>{{ orderDetailData.basic.payway }}</p>
                </div>
                <div>
                  <p>支付时间:</p>
                  <p>{{ orderDetailData.basic.paytime }}</p>
                </div>
                <div>
                  <p>交易编号:</p>
                  <p>{{ orderDetailData.basic.transactionid }}</p>
                </div>
              </div>
              <div class="bottom">
                <div>
                  <p>订单备注:</p>
                  <p>{{ orderDetailData.shipping_address.note }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 时间轴 -->
        <div class="timeLine">
          <div class="main">
            <div class="nav">
              <span>时间轴</span>
            </div>
            <div class="wrap">
              <el-timeline :reverse="true">
                <el-timeline-item
                  v-for="item in orderDetailData.timeflow"
                  :key="item.idx"
                  :color="item.time!=null?'#0bbd87':''"
                  :size="item.size"
                  :timestamp="item.time"
                >{{item.name}}</el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 手动发货 -->
    <el-dialog
      title="选择发货渠道"
      :visible.sync="dialogFormVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="demo-input-suffix">
        发货渠道:
        <el-select
          class="searchInput searchInput2"
          size="mini"
          v-model="logistics"
          placeholder="请选择"
        >
          <el-option
            v-for="item in logisticsList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="editTrack(orderDetailData.manualship)">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 重发 -->
    <el-dialog
      title="选择发货渠道"
      :visible.sync="dialogFormVisible2"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="demo-input-suffix">
        发货渠道:
        <el-select
          class="searchInput searchInput2"
          size="mini"
          v-model="logistics"
           value-key="code"
          placeholder="请选择"
        >
          <el-option
            v-for="item in logisticsList"
            :key="item.code"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="retry">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改发货信息 -->
    <el-dialog
      title="修改发货信息"
      :visible.sync="dialogFormVisible3"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="content">
        <el-form class="forms" ref="form" :model="shipping_address" label-width="90px">
          <el-form-item label="收货姓名:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.name"
              placeholder="请输入收货姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.phone"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="国家:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.country"
              placeholder="请输入国家"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮编:">
            <el-input class="oinput" size="mini" v-model="shipping_address.zip" placeholder="请输入邮编"></el-input>
          </el-form-item>
          <el-form-item label="省份/州:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.province"
              placeholder="请输入省份/州"
            ></el-input>
          </el-form-item>
          <el-form-item label="城市:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.city"
              placeholder="请输入城市"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址1:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.address1"
              placeholder="请输入地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址2:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.address2"
              placeholder="请输入地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="订单备注:">
            <el-input
              class="oinput"
              size="mini"
              v-model="shipping_address.note"
              placeholder="请输入订单备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="btns">
          <el-button type="primary" size="mini" @click="editAddress">确 定</el-button>
          <el-button size="mini" @click="dialogFormVisible3 = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 修改订单信息 -->
    <el-dialog
      title="修改订单信息"
      :visible.sync="dialogFormVisible4"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="content">
        <el-form class="forms" ref="form" :model="shipping_address" label-width="90px">
          <el-form-item label="运单号:">
            <el-input class="oinput" size="mini" v-model="trackno" placeholder="请输入运单号"></el-input>
          </el-form-item>
        </el-form>
        <div class="btns">
          <el-button type="primary" size="mini" @click="editTrackno">确 定</el-button>
          <el-button size="mini" @click="dialogFormVisible4 = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderDetailData,
  editOrderDetail,
  getUnifyShip,
  readd,
  getK5,
  getOrderData,
  k5Update
} from "../../service";
import { GetOrderDetail,GetOrder,GetCurCompanyAttachTransChannel  } from "@/utils/api"
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      isShow: false,
      orderDetailData: { basic: {}, shipping_address: {}, goodslist: [] },
      trackingno: "", //手动发货运单号
      trackno: null, //修改订单信息中的运单号
      k5Data: [], //物流信息列表数据
      orderList: {}, //订单列表数据
      orderData: {}, //从订单列表中的数据
      shipping_address: {
        name: "",
        phone: "",
        country: "",
        zip: "",
        province: "",
        city: "",
        address1: "",
        address2: "",
        note: ""
      },
      input: "",
      form: {},
      dialogFormVisible: false, //手动发货弹出层
      dialogFormVisible2: false, //重发弹出层
      dialogFormVisible3: false, //修改发货信息弹出层
      dialogFormVisible4: false, //修改订单弹出层
      logisticsList: [
        //物流列表
        {
          code: "SZGHXB",
          name: "深圳挂号小包"
        },
        {
          code: "GZEUB",
          name: "广州E邮宝"
        },
        {
          code: "ZOTLGHXB",
          name: "中欧铁路挂号小包"
        },
        {
          code: "HLGHXB",
          name: "荷兰邮政挂号小包"
        }
      ],
      logistics: "", //物流列表选中
      totalPrice:0,
      Total:0,
      totalShippingPrice:0
    };
  },
  computed: {
    ...mapState(["orderDetailParams"]),
  },
  created() {
    this.getOrderDetail();
    this.getK5Data();
    this.getOrder();
    this.getCurCompanyAttachTransChannel();
  },
  methods: {
    ...mapMutations(["setOrderDetailParamsP"]),
    // 获取订单详情
    getOrderDetail() {
      // getOrderDetailData(this.$route.query.id).then(res => {
      //   if (res.data.code === 0) {
      //     this.orderDetailData = JSON.parse(JSON.stringify(res.data.result));
      //     this.shipping_address = JSON.parse(
      //       JSON.stringify(res.data.result.shipping_address)
      //     );
      //   }
      // });
       GetOrderDetail({
        orderId:this.$route.query.id
      }).then(res=>{
        if(res){
          this.orderDetailData = JSON.parse(JSON.stringify(res));
          this.shipping_address = JSON.parse(
            JSON.stringify(res.shipping_address)
          );
           this.Total = res.subTotalPrice; //总计
           this.orderData.shipprice = res.totalShippingPrice; //运费
           this.totalPrice= res.subTotalPrice;
           this.Total = res.totalPrice; //总计
           this.totalShippingPrice = res.totalShippingPrice; //运费
           this.totalPrice= res.subTotalPrice;
        }
      })
    },
    //获取当前公司相关的货运渠道
    getCurCompanyAttachTransChannel(){
      GetCurCompanyAttachTransChannel({
        companyId:sessionStorage.getItem("companyId")
      }).then(res=>{
        if(res){
          this.logisticsList = [];
          res.transConfigSdkWithCompanies.forEach(v=>{
            this.logisticsList.push({
              code:v.channelCode,
              name:v.channelName,
              sdkCode:v.sdkCode
            })
          })
        }
      })
    },
    // 获取订单列表数据=>供前进后退使用
    getOrder(p) {
      let params = JSON.parse(JSON.stringify(this.orderDetailParams));
      if (p) {
        params.p = p;
      }
      GetOrder(params).then(res => {
        if (res) {
          this.orderList = res;
          this.orderList.page.map((el, i) => {
            if (el.id == this.$route.query.id) {
              this.orderData = el;
            }
          });
        }
      });
    },
    // 修改客户收货地址
    editAddress() {
      let params = {
        id: this.$route.query.id - 0, //将字符串id转化成数字
        type: 0,
        order: {
          note: this.shipping_address.note,
          shipping_address: {
            name: this.shipping_address.name,
            phone: this.shipping_address.phone,
            country: this.shipping_address.country,
            zip: this.shipping_address.zip,
            province: this.shipping_address.province,
            city: this.shipping_address.city,
            address1: this.shipping_address.address1,
            address2: this.shipping_address.address2
          }
        }
      };
      editOrderDetail(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "修改信息成功",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.$router.go();
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //发货
    editTrack(i) {
      // 发货
      let params = {
        channelcode: this.logistics,
        orderfileter: {
          ids: [this.$route.query.id - 0],
          select: 0
        }
      };
      getUnifyShip(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: "发货成功",
            type: "success",
            duration: "1000",
            onClose: () => {
              this.$router.go();
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 返回主页
    enterShopifyOrder() {
      this.$router.push({
        path: "/shopifyOrder"
      });
    },
    // 重发（重新发货）
    retry() {
      let params = {
        id: this.$route.query.id - 0,
        channelcode: this.logistics.code,
        sdkCode:this.logistics.sdkCode
      };
      readd(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: "重新发货成功！",
            type: "success",
            duration: "1000",
            onClose: () => {
              this.$router.go();
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取物流列表数据
    getK5Data() {
      let params = {
        id: this.$route.query.id
      };
      getK5(params).then(res => {
        if (res.data.code === 0) {
          this.k5Data = res.data.result;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 前进到上一个订单
    goForward() {
      let index = null; //当前id的在订单列表中的下标
      console.log(this.orderList.page)
      this.orderList.page.map((el, i) => {
        if (el.id == this.$route.query.id) {
          index = i;
        }
      });
      if (index <= 0 && this.orderDetailParams.p > 1) {
        //向前翻一大页
        let params = JSON.parse(JSON.stringify(this.orderDetailParams));
        params.p = parseInt(this.orderDetailParams.p - 1);
        getOrderData(params).then(res => {
          if (res.data.code === 0) {
            this.orderList = res.data.result;
            this.setOrderDetailParamsP(this.orderDetailParams.p - 1);
            this.orderList.page.map((el, i) => {
              if (
                el.id == this.orderList.page[this.orderList.page.length - 1].id
              ) {
                this.orderData = el;
              }
            });
            this.$router.push({
              path: "/orderDetail",
              query: {
                id: this.orderList.page[this.orderList.page.length - 1].id
              }
            });
            this.getOrderDetail();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        if (index > 0) {
          this.orderList.page.map((el, i) => {
            if (el.id == this.orderList.page[index - 1].id) {
              this.orderData = el;
            }
          });
          console.log(this.orderData);
          this.$router.push({
            path: "/orderDetail",
            query: {
              id: this.orderList.page[index - 1].id
            }
          });
          this.getOrderDetail();
        } else {
          this.$message({
            message: "亲,这已经是第一个订单了！",
            type: "warning"
          });
        }
      }
    },
    // 后退到下一个订单
    retreat() {
      let index = null; //当前id的在订单列表中的下标
      this.orderList.page.map((el, i) => {
        if (el.id == this.$route.query.id) {
          index = i;
        }
      });
      if (
        index === this.orderList.page.length - 1 &&
        this.orderDetailParams.p < this.orderList.pnum
      ) {
        //向后翻一大页
        let params = JSON.parse(JSON.stringify(this.orderDetailParams));
        params.p = parseInt(this.orderDetailParams.p + 1);
        getOrderData(params).then(res => {
          if (res.data.code === 0) {
            this.orderList = res.data.result;
            this.setOrderDetailParamsP(this.orderDetailParams.p + 1);
            this.orderList.page.map((el, i) => {
              if (el.id == this.orderList.page[0].id) {
                this.orderData = el;
              }
            });
            this.$router.push({
              path: "/orderDetail",
              query: {
                id: this.orderList.page[0].id
              }
            });
            this.getOrderDetail();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        if (index < this.orderList.page.length - 1) {
          this.orderList.page.map((el, i) => {
            if (el.id == this.orderList.page[index + 1].id) {
              this.orderData = el;
            }
          });
          this.$router.push({
            path: "/orderDetail",
            query: {
              id: this.orderList.page[index + 1].id
            }
          });
          this.getOrderDetail();
        } else {
          this.$message({
            message: "亲,这已经是最后一个订单了！",
            type: "warning"
          });
        }
      }
    },
    // 修改运单号
    editTrackno() {
      let params = {
        id: this.$route.query.id - 0,
        trackingno: this.trackno
      };
      k5Update(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "修改成功",
            type: "success",
            duration: "1000",
            onClose: () => {
              this.$router.go();
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(35, 35, 112, 0.2),
    0 0 0 1px rgba(67, 67, 145, 0.05);
  border-radius: 2px;
  margin-bottom: 20px;
  > .nav {
    height: 30px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  > .content {
    padding: 0px 8px 30px 30px;
    > div {
      > h3 {
        margin-bottom: 16px;
      }
      > div {
        > span {
          display: inline-block;
          width: 30%;
          line-height: 30px;
          > span > span {
            color: rgba(0, 0, 0, 0.65);
          }
          > span > a {
            color: #1890ff;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.btn {
  margin-top: 10px;
}
.forms {
  .el-form-item {
    margin-bottom: 0px;
    /deep/ .el-input__inner {
      width: 80%;
    }
  }
}
.oinput {
  width: 400px;
}
.btns {
  text-align: center;
  margin-top: 20px;
}
.content {
  > .nav,
  > .item {
    height: 42px;
    line-height: 20px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    span:nth-child(1) {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 16px;
    }
    span:nth-child(2) {
      display: inline-block;
      line-height: 14px;
      text-align: center;
      width: 20%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
  }
  > .nav {
    // margin-bottom: 10px;
  }
  > .item {
    background-color: #fff;
    align-items: flex-start;
    height: auto;
    margin-bottom: 8px;
  }
  > .payItem {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #dcddeb;
    display: flex;
    justify-content: space-between;
    color: #2e375e;
    > .left {
      span:first-child {
        display: inline-block;
        width: 100px;
      }
    }
  }
  > .payItem:last-child {
    border-bottom: none;
  }
}
.orderNote {
  width: 25% !important;
  > span {
    width: 99%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      cursor: pointer;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 0 20px;
}
/deep/ .el-dialog__footer {
  padding-top: 0px;
}
.trou {
  display: inline-block;
  padding: 0 20px;
  margin-left: 100px;
  font-weight: 600;
  color: red;
  font-size: 20px;
}
.main2 {
  .content {
    > .nav,
    > .item {
      background-color: #fafafa;
      height: 52px;
      line-height: 20px;
      padding: 0 10px;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      span:nth-child(1) {
        display: inline-block;
        text-align: center;
        width: 20%;
      }
      span:nth-child(2) {
        display: inline-block;
        text-align: center;
        width: 20%;
      }
      span:nth-child(3) {
        display: inline-block;
        text-align: center;
        width: 40%;
      }
      span:nth-child(4) {
        display: inline-block;
        text-align: center;
        width: 20%;
      }
    }
    > .item {
      background-color: #fff;
    }
  }
}
/deep/ .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 30px;
}
/deep/ .dialog-footer {
  text-align: center;
}
.Nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  > span:first-child {
    font-size: 18px;
    font-weight: 600;
  }
  > span:last-child {
    display: flex;
    > span:first-child {
      margin-right: 10px;
      display: flex;
      /deep/ .el-button {
        border-radius: 0px;
      }
      /deep/ .el-button + .el-button {
        margin: 0px;
      }
    }
  }
}
.container {
  display: flex;
  justify-content: space-between;
  > .left {
    width: 68%;
    > .main {
      .payContent {
        padding-bottom: 10px;
      }
    }
  }
  > .right {
    width: 30%;
    .main {
      padding: 6px 10px 10px 10px;
      .nav {
        padding: 0;
        margin-bottom: 18px;
      }
    }
    .wrap {
      > .top {
        border-bottom: 1px solid #dcddeb;
        margin-bottom: 12px;
        > div {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          p:first-child {
            width: 80px;
          }
          p:last-child {
            flex: 1;
          }
        }
      }
      > .middle {
        border-bottom: 1px solid #dcddeb;
        margin-bottom: 12px;
        > div {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          p:first-child {
            width: 80px;
          }
          p:last-child {
            flex: 1;
          }
        }
      }
      > .bottom {
        > div {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          p:first-child {
            width: 80px;
          }
          p:last-child {
            flex: 1;
          }
        }
      }
    }
  }
}
.orderProduct {
  > div {
    display: flex;
    align-items: center;
    > .right {
      a {
        line-height: 0px !important;
        text-decoration: underline;
        color: #273a81;
        font-size: 14px;
        &:hover {
          cursor: pointer;
        }
      }
      p {
        margin-top: 4px;
        color: #696b74;
      }
    }
  }
}
.logisticsMain {
  .content {
    > .nav,
    > .item {
      height: 42px;
      line-height: 20px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      span:nth-child(1) {
        display: inline-block;
        width: 20%;
        text-align: center;
        line-height: 16px;
      }
      span:nth-child(2) {
        display: inline-block;
        line-height: 14px;
        text-align: center;
        width: 20%;
      }
      span:nth-child(3) {
        display: inline-block;
        text-align: center;
        width: 40%;
      }
      span:nth-child(4) {
        display: inline-block;
        text-align: center;
        width: 16%;
      }
    }
  }
}
</style>